<ion-content padding="false" no-padding class="has-header" scroll="false" data-cy="signUp-landingScreen">

  <div id="signUpContainer">

    <div id="signUpLeftDiv">

      <div class="signUpText1">


        <div class="signUpLogo" data-cy="signUp-welcomeInfo-logo">
          <img src="assets/imgs/signUpLogo.png">
          <!-- 
          <img *ngIf="variant === 'onlylink-sign-up-a'" src="assets/imgs/onlylink-powered-by-block-party.png"> -->
        </div>

        <div *ngIf="!variant" class="signUpP1" data-cy="signUp-welcomeInfo-title">
          {{welcomeMessage}}
        </div>

        <div *ngIf="variant === '' && !agentAdminChecked.isChecked && !lenderChecked.isChecked" class="signUpP2"
          data-cy="signUp-welcomeInfo-subtitle">100% free for agents
        </div>

        <div *ngIf="variant === 'onlylink-sign-up-a'" class="signUpP1">You are one step away from turning your social
          media bio into a lead magnet.</div>

        <div *ngIf="variant === 'onlylink-sign-up-a' && !lenderChecked.isChecked" class="signUpP2">100% free for agents
        </div>

        <div *ngIf="variant === 'lender-invite-aa'" class="signUpP1">Get in front of buyers that are actively looking at
          property</div>
        <div *ngIf="variant === 'lender-invite-aa'" class="signUpP2">There are mortgage leads...<strong>and then there
            are
            these.</strong>
        </div>

        <div *ngIf="variant === 'open-house-sign-up-a'" class="signUpP1">Love new clients, but hate their handwriting?
          There's an app for that.</div>
        <div *ngIf="variant === 'open-house-sign-up-a' && !lenderChecked.isChecked" class="signUpP2">100% free for
          agents</div>

      </div>

      <img *ngIf="variant !== 'open-house-sign-up-a'" class="signUpGraphic"
        src="assets/imgs/Create_account_graphic_3_Products_1.png" data-cy="signUp-welcomeInfo-img">

      <img *ngIf="variant === 'open-house-sign-up-a'" class="signUpGraphic"
        src="assets/imgs/Create_account_graphic_openhouseapp_promo.png" data-cy="signUp-welcomeInfo-img">

    </div>

    <div id="signUpDiv">

      <div id="alreadySignedup">

        <span class="haveAccount">Already have an account? </span><span class="link" (click)="openLoginPage()"
          data-cy="signUp-form-alreadyHaveAccount-loginBtn">Sign in</span>
      </div>

      <div class="formWrapper" [style.padding-bottom.px]="utils.keyboardHeight">

        <div (click)="openLoginPage()" id="alreadySignedup2">
          Already have an account?<span class="link" data-cy="signUp-form-alreadyHaveAccount-loginBtn">Sign in</span>
        </div>

        <div class="margin-left-15">


          <ion-label class="roleLabel" data-cy="signUp-form-interest-txt">Role
          </ion-label>

          <div class="role-wrapper full-width">

            <ion-item class="checkbox-form-wrapper link"
              [ngClass]="agentChecked.isChecked ? 'disableClicks' : 'enableClicks'" text-wrap>
              <ion-checkbox labelPlacement="end" slot="start" mode="ios" (click)="updateRole('agent')" color="primary"
                [(ngModel)]="agentChecked.isChecked" data-cy="signUp-form-interest-realEstate-checkbox">
                <ion-label class="checkboxLabel" data-cy="signUp-form-interest-realEstate-txt">Agent</ion-label>

              </ion-checkbox>
            </ion-item>

            <ion-item class="checkbox-form-wrapper link"
              [ngClass]="lenderChecked.isChecked ? 'disableClicks' : 'enableClicks'" text-wrap>

              <ion-checkbox labelPlacement="end" slot="start" (click)="checkToRedirectToWebForLenderSignup()" mode="ios"
                color="primary" [(ngModel)]="lenderChecked.isChecked" data-cy="signUp-form-interest-mortgage-checkbox">
                <ion-label class="checkboxLabel" data-cy="signUp-form-interest-mortgage-txt">Lender</ion-label>
              </ion-checkbox>
            </ion-item>

            <ion-item class="checkbox-form-wrapper link"
              [ngClass]="agentAdminChecked.isChecked ? 'disableClicks' : 'enableClicks'" text-wrap>
              <ion-checkbox labelPlacement="end" slot="start" (click)="checkToRedirectToWebForAdminSignup()" mode="ios"
                color="primary" [(ngModel)]="agentAdminChecked.isChecked"
                data-cy="signUp-form-interest-agent-admin-checkbox">
                <ion-label class="checkboxLabel" data-cy="signUp-form-interest-agent-admin-txt">Team Admin</ion-label>

              </ion-checkbox>
            </ion-item>

          </div>

          <!-- <div>
            <div class="roleBtn">
              <ion-button [fill]="btnRealEstate" class="link" (click)="updateRole('agent')" 
                data-cy="signUp-form-interest-realEstate-btn">
                Real Estate
              </ion-button>
              <ion-button [fill]="btnMortgage" class="link"  (click)="checkToRedirectToWebForLenderSignup()"
                data-cy="signUp-form-interest-mortgage-btn">
                Mortgage
              </ion-button>
              <ion-button [fill]="btnTeamAdmin" *ngIf="variant === 'agent-admin-aa'" class="link" (click)="checkToRedirectToWebForAdminSignup()" 
                data-cy="signUp-form-interest-agent-admin-btn">
                Team Admin
              </ion-button>
            </div>
          </div> -->
        </div>
        <form (ngSubmit)="signupWrapper()" [formGroup]="signUpForm" class="list center-form">
          <p *ngIf="submitAttempt" style="color: #ea6153;">{{signUpError}}</p>
          <ion-item>
            <ion-label position="floating" data-cy="signUp-form-name-txt">Full Name</ion-label>
            <ion-input mode="ios" autocapitalize="words"
              [class.invalid]="!signUpForm.controls.name.valid && (signUpForm.controls.name.dirty|| submitAttempt)"
              type="text" autocomplete="name" formControlName="name" (ionBlur)="resetFields('name')"
              (ionFocus)="resetFields('name')" spellcheck="false" data-cy="signUp-form-name-input"></ion-input>
          </ion-item>
          <div *ngIf="!nameValid" data-cy="signUp-form-name-errorMsg">
            <span class="errorMsg" *ngIf="signUpForm.controls.name.errors.required">Please enter your full name</span>
            <span class="errorMsg" *ngIf="signUpForm.controls.name.errors.minlength">{{
              i8nService.messages.signupNameMinimumCharacters }}</span>
            <span class="errorMsg" *ngIf="signUpForm.controls.name.errors.pattern">{{
              i8nService.messages.signupNameInvalidCharacters }}</span>
          </div>
          <ion-item>
            <ion-label position="floating" data-cy="signUp-form-number-txt">Mobile Number</ion-label>
            <ion-input
              [class.invalid]="!signUpForm.controls.phone.valid && (signUpForm.controls.phone.dirty|| submitAttempt)"
              type="tel" inputmode="tel" min-length="14" formControlName="phone"
              (input)="onPhoneChange($event.target.value)" (ionBlur)="resetFields('phone')"
              (ionFocus)="resetFields('phone')" autocomplete="tel" spellcheck="false"
              data-cy="signUp-form-number-input">
            </ion-input>
          </ion-item>


          <div *ngIf="!phoneValid" data-cy="signUp-form-number-errorMsg">
            <span class="errorMsg">{{ i8nService.messages.enterValidPhoneNumber }}</span>


          </div>
          <ion-item>
            <ion-label position="floating" data-cy="signUp-form-email-txt">Email</ion-label>
            <ion-input mode="ios"
              [class.invalid]="!signUpForm.controls.email.valid && (signUpForm.controls.email.dirty|| submitAttempt)"
              type="email" value="" autocomplete="email" formControlName="email" (ionBlur)="resetFields('email')"
              (ionFocus)="resetFields('email')" data-cy="signUp-form-email-input"></ion-input>
          </ion-item>


          <div *ngIf="!emailValid" data-cy="signUp-form-email-errorMsg">
            <span class="errorMsg">{{ i8nService.messages.enterValidEmail }}</span>


          </div>
          <ion-item lines="none">
            <ion-label position="floating" data-cy="signUp-form-password-txt">Password</ion-label>
            <ion-input mode="ios"
              [class.invalid]="!signUpForm.controls.password.valid && (signUpForm.controls.password.dirty|| submitAttempt)"
              type="password" value="" formControlName="password" (ionBlur)="resetFields('password')" autocomplete="off"
              (ionFocus)="resetFields('password')" data-cy="signUp-form-passw-input"></ion-input>
          </ion-item>

          <div *ngIf="!passwordValid" data-cy="signUp-form-password-errorMsg">
            <span class="errorMsg" *ngIf="signUpForm.controls.password.errors.required">{{
              i8nService.messages.enterValidPasswordLength }}</span>
            <span class="errorMsg" *ngIf="signUpForm.controls.password.errors.minlength">{{
              i8nService.messages.enterValidPasswordLength }}</span>
            <span class="errorMsg" *ngIf="signUpForm.controls.password.errors.passwordDomain">
              {{signUpForm.controls.password.errors.passwordDomain.parsedDomain}}
            </span>
          </div>
          <ion-item lines="none" class="checkbox-form-wrapper" class="ion-text-wrap margin-left-15 margin-top-10">

            <ion-checkbox labelPlacement="end" slot="start" mode="ios" formControlName="termsAndConditions"
              data-cy="signUp-form-termsAndCond-checkbox"> <ion-label class="lightText ion-text-wrap"
                [class.invalid-checkbox]="!signUpForm.controls.termsAndConditions.valid && (signUpForm.controls.termsAndConditions.dirty|| submitAttempt)"
                data-cy="signUp-form-termsAndCond-txt">
                <span class="normal">I agree to the </span><a class="bold color-primary link" (click)="readTerms($event)">Curb
                  Hero Terms and Conditions</a>
              </ion-label></ion-checkbox>
          </ion-item>
          <div class="spacer-10"></div>

          <!-- <a id="signUpLink" href="#" name="signUpBtn" onclick="dataLayer.push({'event': 'signup'});"> -->
          <ion-button [disabled]="disableSignup || !signUpForm.controls.termsAndConditions.valid" expand="block"
            id="signUpButton" type="submit" ion-button color="primary" full
            data-cy="signUp-form-termsAndCond-getStartedBtn">Get Started
          </ion-button>
          <!-- </a> -->

        </form>

        <!--
        <ion-item class="accountTypeSelect2">
          <ion-label>Account Type</ion-label>
          <ion-select [(ngModel)]="role">
            <ion-select-option value="agent">Agent</ion-select-option>
            <ion-select-option value="lender">Lender</ion-select-option>
          </ion-select>
        </ion-item>
-->
      </div>
    </div>
  </div>

</ion-content>